import { Draggable } from "react-beautiful-dnd"

const QuestionDraggable = ({id , index , children})=>{
    return  <Draggable draggableId={`${id}`} index={index}>
    {(provided) => (
      <div
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
      >
        <div style={{marginBottom : '1rem' , width : '100%'}}> 
        {children}
        </div>
      </div>)}
      </Draggable>
}
export default QuestionDraggable;